import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import UserImpersonate from './UserImpersonate';
import { Link } from 'react-router-dom';
import { canImpersonate, canManageUsers } from "../../PermissionSelectors";
import { connect } from "react-redux";
import Pagination from "../navigation/Pagination";
import { getUserCustomers, mapPrimaryAccountType } from "../../actions/UserActions";
import { updateState } from "../../actions/CommonActions";
import * as types from "../../constants/ActionTypes";
import { clearSessionPaymentMethods } from "../../reducers/PaymentReducer";

class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            impersonatedUserId: null, // Centralized state for impersonation
        };
       /* this.handleImpersonate = this.handleImpersonate.bind(this);*/
    }

    //handleImpersonate(userId) {
    //    const newImpersonatedUserId =
    //        userId === this.state.impersonatedUserId ? null : userId;

    //    // Update state
    //    this.setState({ impersonatedUserId: newImpersonatedUserId });

    //    // Update session storage
    //    sessionStorage.setItem('impersonatedUserId', newImpersonatedUserId || "");

    //    // Dispatch necessary actions
    //    if (newImpersonatedUserId) {
    //        this.props.dispatch(getUserCustomers(this.props.dispatch, newImpersonatedUserId));
    //        const user = this.props.users.find((u) => u.UserId === newImpersonatedUserId);
    //        if (user) {
    //            this.props.dispatch(
    //                updateState(this.props.dispatch, types.SET_ACCOUNT_TYPE, mapPrimaryAccountType(user.PrimaryAccountTypeId))
    //            );
    //        }
    //    } else {
    //        this.props.dispatch(clearSessionPaymentMethods());
    //    }
    //}

    impersonateFormatter(cell, row) {
        return (
            <UserImpersonate
                user={row}
            />
        );
    }

    userName(cell, row) {
        if (row) {
            if (this.props.canManageUsers) {
                return <Link to={`/settings/users/${row.UserId}`}>{row.Login}</Link>;
            } else {
                return cell;
            }
        }
    }

     formatColumn(cell, row) {

    if (row) {

        return (`${ '<div class="truncate"><span>' }${ row.Company }${ '</span></div>' }`);

    }

}

  formatEmailColumn(cell, row) {

    if (row) {

        return (`${ '<div class="truncate"><span>' }${ row.Email }${ '</span></div>' }`);

    }

}

//  impersonateFormatter(cell, row) {   

//    return <UserImpersonate user={row} />;
//};

  formatStatusColumn(cell, row) {

    if (row.Status === 'active') {

        return (<span className="status-green">{row.Status}</span>);

    }

    return (<span className="status-red">{row.Status}</span>);

}

  nameColumn(cell, row) {

    if (row.FirstName || row.LastName) {

        return (`${ '<div class="truncate"><span>' }${ row.FirstName } ${ row.LastName }${ '</span></div>' }`);

    }

}

  profileColumn(cell, row) {

    let display = "";

    if (row.PrimaryAccountTypeId === 1) {

        display = "Sold To";

    } else if (row.PrimaryAccountTypeId === 2) {

        display = "Payer";

    } else if (row.PrimaryAccountTypeId === 3) {

        display = "Payer - All";

    }

    return (`${ '<div class="truncate"><span>' }${ display }${ '</span></div>' }`);

}

 accountsColumn(cell, row) {

    let accountNumbers = [];

    if (row.Accounts != undefined)

        row.Accounts.forEach((a) => accountNumbers.push(a.PrimaryAcct));

    if (accountNumbers.length > 0) {

        return (`${ '<div class="truncate"><span>' }${ accountNumbers.join(", ") }${ '</span></div>' }`);

    }

}

    render() {
        return (
            <div>
                <BootstrapTable
                    data={this.props.users}
                    tableHeaderClass="user-list-table-header"
                    tableContainerClass="wa-bootstrap-table-container"
                    tableBodyClass="wa-bootstrap-small-text"
                >
                    {this.props.canImpersonate &&(
                        <TableHeaderColumn
                            width="50"
                            className="headerColumnColor"
                            dataAlign="center"
                            dataField="login"
                            dataFormat={this.impersonateFormatter.bind(this)}
                        >
                            Impersonate
                        </TableHeaderColumn>
                    )}
                    <TableHeaderColumn
                        width="65"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataField="login"
                        dataFormat={this.userName.bind(this)}
                        isKey
                    >
                        User Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataFormat={this.nameColumn.bind(this)}
                    >
                        Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataField="company"
                        dataFormat={this.formatColumn.bind(this)}
                    >
                        Company
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataField="email"
                        dataFormat={this.formatEmailColumn.bind(this)}
                    >
                        eMail
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataField="status"
                        dataFormat={this.formatStatusColumn.bind(this)}
                    >
                        Status
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataFormat={this.profileColumn.bind(this)}
                    >
                        Profile
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="55"
                        className="headerColumnColor"
                        dataAlign="center"
                        dataField="accounts"
                        dataFormat={this.accountsColumn.bind(this)}
                    >
                        Accounts
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

UserList.propTypes = {
    users: PropTypes.array.isRequired,
};

export default connect((state, props) => ({
    canManageUsers: canManageUsers(state, props),
    canImpersonate: canImpersonate(state, props)
}))(UserList);
